import { VueConstructor } from 'vue'

// layouts
import vFrontend from '../layouts/frontend/index.vue'

// components
import vBox from '../components/vBox.vue'
import vContact from '../components/vContact.vue'
import vContactAddress from '../components/vContactAddress.vue'
import vContactWhatsApp from '../components/vContactWhatsApp.vue'
import vCountry from '../components/vCountry.vue'
import vDivider from '../components/vDivider.vue'
import vFilter from '../components/vFilter.vue'
import vGoBack from '../components/vGoBack.vue'
import vGrid from '../components/vGrid.vue'
import vHeader from '../components/vHeader.vue'
import vHistories from '../components/vHistories.vue'
import vIcon from '../components/vIcon.vue'
import vLoad from '../components/vLoad.vue'
import vLoader from '../components/vLoader.vue'
import vMap from '../components/vMap.vue'
import vMenu from '../components/vMenu.vue'
import vModal from '../components/vModal.vue'
import vProperties from '../components/vProperties.vue'
import vSearch from '../components/vSearch.vue'
import vSearchShortCuts from '../components/vSearchShortCuts.vue'
import vSelect from '../components/vSelect.vue'
import vSlider from '../components/vSlider.vue'
import vSliderVideos from '../components/vSliderVideos.vue'
import vTab from '../components/vTab.vue'
import vWrapper from '../components/vWrapper.vue'

const components = {
    install(Vue: VueConstructor) {
        // layouts
        Vue.component('v-frontend', vFrontend)
        // components
        Vue.component('v-box', vBox)
        Vue.component('v-contact', vContact)
        Vue.component('v-contact-address', vContactAddress)
        Vue.component('v-contact-whatsapp', vContactWhatsApp)
        Vue.component('v-country', vCountry)
        Vue.component('v-divider', vDivider)
        Vue.component('v-filter', vFilter)
        Vue.component('v-go-back', vGoBack)
        Vue.component('v-grid', vGrid)
        Vue.component('v-header', vHeader)
        Vue.component('v-histories', vHistories)
        Vue.component('v-icon', vIcon)
        Vue.component('v-load', vLoad)
        Vue.component('v-loader', vLoader)
        Vue.component('v-map', vMap)
        Vue.component('v-menu', vMenu)
        Vue.component('v-modal', vModal)
        Vue.component('v-properties', vProperties)
        Vue.component('v-search', vSearch)
        Vue.component('v-search-shortcuts', vSearchShortCuts)
        Vue.component('v-select', vSelect)
        Vue.component('v-slider', vSlider)
        Vue.component('v-slider-videos', vSliderVideos)
        Vue.component('v-tab', vTab)
        Vue.component('v-wrapper', vWrapper)
    }
}

export default components
